import type GlobalDataRepositoryInterface from '../interface-adapters/GlobalDataRepositoryInterface';
import GlobalDataRepository from '../repositories/GlobalDataRepository';
import GetGlobalDataUseCase from '../use-cases/GetGlobalDataUseCase';

export default class GlobalDataFactory {
    private static repo: GlobalDataRepositoryInterface;
    private static getGlobalDataUseCase: GetGlobalDataUseCase;

    private constructor() {}

    public static makeRepo(): GlobalDataRepositoryInterface {
        if (!this.repo) {
            this.repo = new GlobalDataRepository();
        }

        return this.repo;
    }

    public static makeGetUseCase(): GetGlobalDataUseCase {
        if (!this.getGlobalDataUseCase) {
            this.getGlobalDataUseCase = new GetGlobalDataUseCase();
        }

        return this.getGlobalDataUseCase;
    }
}
